import i18n from "i18next";
import BrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { IS_PRODUCTION } from "@/constants/environment.constants";
import {
  getEnabledLocales,
  getLanguageResources,
} from "@/helpers/i18n/i18n.helpers";

const browserLanguageDetector = new BrowserLanguageDetector();

const enabledLocales = getEnabledLocales(IS_PRODUCTION);

i18n
  .use(browserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources: getLanguageResources(enabledLocales),
    keySeparator: ".",
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        reseller: "Aircall",
      },
    },
  });

export default i18n;
